export default "assets/30f6cad8e1da7ad07cf2850c0f9e4728.png";